import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { LANDING_ENDCAP_ZOOM, MATCHED_IDLE_SPEED, PAPER, REVEAL_SPACING } from "./shared";
/** Shared low diagonal used by the legal pages so their compositions remain
 * pixel-identical across desktop and mobile (prototype PROP65 == GOVERNANCE). */
const LEGAL_DIAGONAL_STATE = {
    id: "static",
    background: PAPER,
    zoom: 0.72,
    halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
    center: [0.54, 0.7],
    rotationDeg: -14,
    lineExtent: 0.72,
    turbulence: 0.24,
    spacing: REVEAL_SPACING,
    speed: MATCHED_IDLE_SPEED,
    dither: 1,
    spatialColor: 0.38,
    twistRetention: 0.9,
    fanSpread: 0.025,
    twistSpread: 0.052,
    horizontalStretch: 1.48,
    unravel: 0.78,
    curveStrength: 0,
    curveProgress: 0,
    mobile: {
        zoom: 0.48,
        center: [0.52, 0.76],
        rotationDeg: -9,
        lineExtent: 0.8,
        fanSpread: 0.014,
        twistSpread: 0.035,
        horizontalStretch: 1.2,
    },
};
/** Legal: static low diagonal, no waypoints. */
export const LEGAL_PRESET = {
    id: "legal",
    roles: [],
    mobileBreakpoint: 900,
    palette: "primary-v2",
    shape: "line",
    halftone: DEFAULT_RIBBON_HALFTONE_MATERIAL,
    interaction: SUBTLE_RIBBON_INTERACTION,
    initialStateId: "static",
    states: [LEGAL_DIAGONAL_STATE],
    steps: [],
};
//# sourceMappingURL=legal.js.map